import { useCallback, useEffect, useState } from 'react'
import CountUp from 'react-countup'
import { useTranslation } from 'react-i18next'

import { Stack, Typography } from '@mui/material'

import errorHandlerHook from '@hooks/useErrorHandler'

import OpportunityService from '@services/opportunity'

import { MatchesCountIcon } from '@components/MatchesCountIcon'
import { TLGTypography } from '@components/TLGTypography'

import { containerSx, matchesCountNumberSx, matchesCountTextSx } from './styles'

const MatchesCountSection = () => {
  const { t } = useTranslation()
  const { handleError } = errorHandlerHook.useErrorHandler()

  const [totalOpportunitiesCount, setTotalOpportunitiesCount] =
    useState<number>()

  const fetchTotalOpportunitiesCount = useCallback(async () => {
    try {
      const { count } = await OpportunityService.getTotalCount()

      setTotalOpportunitiesCount(count)
    } catch (err) {
      handleError({
        exception: err,
      })
    }
  }, [handleError])

  useEffect(() => {
    fetchTotalOpportunitiesCount()
  }, [fetchTotalOpportunitiesCount])

  return (
    <Stack
      data-testid="tech-vendors-benefits-matches-count-section"
      direction={{ xs: 'column', md: 'row' }}
      sx={containerSx}
    >
      <MatchesCountIcon color="light" size="small" />

      <Typography variant="h4" sx={matchesCountNumberSx}>
        {totalOpportunitiesCount && (
          <CountUp
            start={Math.max(totalOpportunitiesCount - 25, 0)}
            end={totalOpportunitiesCount}
            duration={5}
          />
        )}
      </Typography>
      <TLGTypography
        responsiveVariant={{ xs: 'h6', md: 'h5' }}
        sx={matchesCountTextSx}
      >
        {t('Technology matches to date')}!
      </TLGTypography>
    </Stack>
  )
}

export { MatchesCountSection }
